import { getLocale } from '../lib/i18n'
import { EN, ES, type Kind } from '../../shared/market/legal'

/** The three public pages inside the app. The same text is served as plain pages at /privacy, /terms and /support. */
export default function Legal({kind}:{kind:Kind}){
 const doc=(getLocale()==='en'?EN:ES)[kind]
 return <section className="legal-page">
  <h1>{doc.title}</h1>
  {doc.sections.map(s=><section key={s.h}><h2>{s.h}</h2>{s.p.map((t,i)=><p key={i}>{t}</p>)}</section>)}
 </section>
}
